import React from "react";
// import useEffect
import { useEffect, useState, useRef } from "react";
import { getUserHistory, getUserCredits } from "../utils/userData";
import { useAuth } from "../utils/authContext";
import auth from "../utils/firebaseClient";
import { signOut } from "firebase/auth";
import { GeneralModal } from "./GeneralModal";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Sidebar = ({ isOpen, onClose, aboutOpen }) => {
  const { user, loading } = useAuth();
  const [history, setUserHistory] = useState([]);
  const sidebarRef = useRef(null);
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(aboutOpen);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      // reload page
      window.location.reload();
    } catch (error) {
      console.error("Error signing out:", error.message);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!loading && user) {
      (async () => {
        // get history from supabase
        const data = await getUserHistory(user.uid);
        // reverse the array
        data?.reverse();
        setUserHistory(data);
      })();
    }
  }, [user, loading]);

  const sidebarClasses = isOpen
    ? "fixed top-0 right-0 h-screen w-64 bg-[#4706FF] transition-all duration-300 z-50 border-l border-white shadow-xl  overflow-y-auto "
    : "fixed top-0 right-0 h-screen w-0 bg-[#4706FF] overflow-hidden transition-all duration-300 z-50 ";

  const buttonSectionClasses = isOpen
    ? "fixed bottom-0 right-0 bg-[#4706FF] border-t border-white flex flex-col justify-center items-center p-4 w-64 transition-all duration-300"
    : "fixed bottom-0 right-0 bg-[#4706FF] border-t border-white flex flex-col justify-center items-center  p-4 w-0 transition-all duration-300 opacity-0";

  return (
    <>
      <div className={sidebarClasses} ref={sidebarRef}>
        
        <h1
          className=" stretch font-tnr  leading-tight tracking-tight text-white text-2xl font-bold p-4 w-full
      border-b border-white sticky top-0 bg-[#4706FF] z-50
      "
        >
          History
        </h1>
        <div className="pb-[600px]">
          {history?.map((item, index) => (
            <MusicPlayer key={index} audioSRC={item.audioFileURL} />
          )) ||
            (loading ? (
              <SkeletonTheme baseColor="#4706FF" highlightColor="#5E1FFF">
                <Skeleton height={100} count={6} width="90%" />
              </SkeletonTheme>
            ) : (
              <div className="flex flex-col justify-center items-center w-full h-full font-SF text-white text-lg font-medium gap-4">
                <h1
                  className=" pt-20
            stretch font-tnr  leading-tight tracking-tighter text-white text-3xl font-bold h-full mb-4
          "
                >
                  nothing here yet{" "}
                </h1>
              </div>
            ))}
        </div>

        <div className={buttonSectionClasses}>
          <h2
            className="boxy-shadow font-bold text-white w-[95%] p-2
        bg-red-500 cursor-pointer
        "
            onClick={handleSignOut}
          >
            Sign out
          </h2>
          <div
            className="flex
        justify-between items-center w-[95%] py-2
        "
          >
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;

const playingAudios = [];
let currentPlayingAudio = null;
let setCurrentPlayingAudioIsPlaying = null;

function MusicPlayer({ audioSRC }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [areVocalsIsolated, setAreVocalsIsolated] = useState(false);
  const [audio, setAudio] = useState(null);

  useEffect(() => {
    const newAudio = new Audio(audioSRC);
    newAudio.addEventListener("ended", () => setIsPlaying(false));
    setAudio(newAudio);
    return () => {
      newAudio.removeEventListener("ended", () => setIsPlaying(false));
      newAudio.pause();
      playingAudios.splice(playingAudios.indexOf(newAudio), 1); // Remove audio instance from playingAudios array
    };
  }, []);

  // when audioSRC changes, we need to update the audio
  useEffect(() => {
    if (audio) {
      audio.src = audioSRC;
    }
  }, [audioSRC]);
  const handlePlay = () => {
    // If there is another audio playing, pause it and change its symbol to play
    if (currentPlayingAudio && currentPlayingAudio !== audio) {
      currentPlayingAudio.pause();
      setCurrentPlayingAudioIsPlaying(false);
    }

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play();
      setIsPlaying(true);
      // Update the global variables
      currentPlayingAudio = audio;
      setCurrentPlayingAudioIsPlaying = setIsPlaying;
    }
  };
  return (
    <div className="flex flex-row justify-center items-center w-full h-full">
      <div
        className="w-full h-[100px] bg-white flex justify-center items-center
          cursor-pointer"
        onClick={handlePlay}
      >
        {/* boxy shadow button */}
        <div
          className={`w-full h-[100px] flex justify-center items-center 
            transition-all group border-b border-white bg-[#4706FF]`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="white"
            className="w-24 h-24
              group-active:scale-75 transition-all"
            viewBox="0 0 16 16"
          >
            {!isPlaying ? (
              <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
            ) : (
              <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" />
            )}
          </svg>
        </div>
      </div>
      <div className="w-[50%] h-[100px] flex justify-center items-center
          cursor-pointer border-l border-white border-b
      "
      onClick={() => {
        // download
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = audioSRC;
        link.download = "audio.mp3";
        link.click();

      }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"/>
</svg>
      </div>
    </div>
  );
}
